module.exports = "<div class=\"link-player-modal\">\r\n\r\n\t<div class=\"user-list\">\r\n\r\n\t</div>\r\n\r\n\t<button class=\"btn btn-primary btn-close\">\r\n\t\tClose\r\n\t</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin-section/players/_modals/link-player-modal/link-player-modal.tpl.html
// module id = 67
// module chunks = 0